import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JsonPathViewerComponent } from '../../../../common/json-path-viewer/json-path-viewer.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GanttItem } from '@worktile/gantt';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageHeaderComponent } from "@nucleus/ui-base";


export interface GanttEventDataDialogData {
  item : GanttItem;
}

@Component({
    selector: 'gantt-event-view',
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        JsonPathViewerComponent,
        PageHeaderComponent,
    ],
    templateUrl: './gantt-event-view.component.html',
    styleUrl: './gantt-event-view.component.css'
})
export class GanttEventViewComponent {
  public jsonData: any;
  item :  GanttItem;
  copied = false;


  constructor(
    public dialogRef: MatDialogRef<GanttEventDataDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: GanttEventDataDialogData,
    public snackBar: MatSnackBar ) { 
      this.item = data.item;
      this.jsonData = data.item;
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.item.id);
    this.copied = true;
    this.snackBar.open('ID copied to clipboard', 'OK', 
      { 
        duration: 2000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom' 
      });
  }

  copyJSONToClipboard(): void {
    navigator.clipboard.writeText(JSON.stringify(this.jsonData));
    this.copied = false;
    this.snackBar.open('JSON copied to clipboard', 'OK', 
      { 
        duration: 2000 ,
        horizontalPosition: 'right',
        verticalPosition: 'bottom'
      });
  }
}
